import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left w-full min-h-150" }
const _hoisted_2 = { class: "col-span-2 sm:col-span-1" }
const _hoisted_3 = { class: "col-span-2 sm:col-span-1 order-3 sm:order-2" }
const _hoisted_4 = { class: "col-span-1 text-right order-2 sm:order-3" }
const _hoisted_5 = {
  key: 0,
  class: "px-5 bg-brandy inline-block cursor-default"
}
const _hoisted_6 = ["onClick"]

import {
    BasketDeliveryAddress,
    PartnerAddress,
} from '@/b2b/shared/api/server-apis';
import { useCheckout } from '@/b2b/checkout/useCheckout';
import { useStepReset } from '@/b2b/checkout/useStepReset';
import BasketDeliverableDialog from '@/b2b/basket/ui/BasketDeliverableDialog.vue';
import { ref, watch } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutChangeAddress',
  props: {
    isOpen: { type: Boolean, default: false },
    deliveryAddress: { default: undefined }
  },
  emits: ['close', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { isOpen: boolean, deliveryAddress: BasketDeliveryAddress }




const labels = useBlockLabels();
const resetStep = useStepReset();
const { setDeliveryAddress, getDeliveryAddresses } = useCheckout();

const addresses = ref<PartnerAddress[]>([] as PartnerAddress[]);

const init = async() => {
    addresses.value = await getDeliveryAddresses();
};

const getIsChosenAddress = (id: string) => {
    return id === props.deliveryAddress?.address?.id;
};

const chooseAddress = async(id: string) => {
    await setDeliveryAddress(id);
    resetStep();
    close();
    emit('change');
};

watch(() => props.isOpen, (open) => {
    if (open) {
        init();
    }
}, { immediate: true });

const close = (): void => {
    emit('close');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasketDeliverableDialog, {
    "is-open": __props.isOpen,
    heading: _unref(labels).customerDeliveryShippingChangeAddressHeading,
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("dl", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addresses.value, (address) => {
          return (_openBlock(), _createElementBlock("div", {
            key: address.id,
            class: "grid grid-cols-3 mb-x3"
          }, [
            _createElementVNode("dt", _hoisted_2, _toDisplayString(address.addressDescription), 1),
            _createElementVNode("dd", _hoisted_3, [
              _createTextVNode(_toDisplayString(address.street) + " ", 1),
              (address?.street2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" , " + _toDisplayString(address?.street2), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createTextVNode(" , " + _toDisplayString(address.zipCode) + " " + _toDisplayString(address.city), 1)
            ]),
            _createElementVNode("dd", _hoisted_4, [
              (getIsChosenAddress(address.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(labels).customerDeliveryShippingChangeAddressIsSelectedInList), 1))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "c-magic-line c-magic-line--underline text-dusty-grey",
                    onClick: ($event: any) => (chooseAddress(address.id))
                  }, _toDisplayString(_unref(labels).customerDeliveryShippingChangeAddressSelectFromList), 9, _hoisted_6))
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-open", "heading"]))
}
}

})